import { render, staticRenderFns } from "./_factories.vue?vue&type=template&id=1f5c089d&scoped=true&"
import script from "./_factories.vue?vue&type=script&lang=js&"
export * from "./_factories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5c089d",
  null
  
)

export default component.exports